import i18n from "@/i18n";
import { VariableItem } from "@/modules/ckeditor/TextEditor";

export const PAGECONFIG_TO_PIXEL_RATIO = 3.78;
export const LETTER_HEADER_VARIABLE: () => VariableItem[] = () => [
  ...OBJECT_VARIABLE(),
  {
    id: "activityId",
    name: i18n.t("BFDocument.variables.activityId", "Aktenzeichen"),
  },
  {
    id: "documentDate",
    name: i18n.t("BFDocument.variables.documentDate", "Datum"),
  },
  {
    id: "receiverName",
    name: i18n.t("BFDocument.variables.receiverName", "Empfänger - Name"),
  },
  {
    id: "receiverStreet",
    name: i18n.t("BFDocument.variables.receiverStreet", "Empfänger - Straße"),
  },
  {
    id: "receiverCity",
    name: i18n.t("BFDocument.variables.receiverCity", "Empfänger - Stadt"),
  },
  {
    id: "receiverCountry",
    name: i18n.t("BFDocument.variables.receiverCountry", "Empfänger - Land"),
  },

  {
    id: "senderName",
    name: i18n.t("BFDocument.variables.senderName", "Absender - Name"),
  },
  {
    id: "senderStreet",
    name: i18n.t("BFDocument.variables.senderStreet", "Absender - Straße"),
  },
  {
    id: "senderZip",
    name: i18n.t("BFDocument.variables.senderZip", "Absender - PLZ"),
  },
  {
    id: "senderCity",
    name: i18n.t("BFDocument.variables.senderCity", "Absender - Stadt"),
  },
  {
    id: "senderCountry",
    name: i18n.t("BFDocument.variables.senderCountry", "Absender - Land"),
  },

  {
    id: "senderPhone",
    name: i18n.t("BFDocument.variables.senderPhone", "Absender - Telefon"),
  },
  {
    id: "senderFax",
    name: i18n.t("BFDocument.variables.senderFax", "Absender - Fax"),
  },
  {
    id: "senderMail",
    name: i18n.t("BFDocument.variables.senderMail", "Absender - Email"),
  },
  {
    id: "senderWebsite",
    name: i18n.t("BFDocument.variables.senderWebsite", "Absender - Webseite"),
  },
  ...BANK_VARIABLE(),
];

export const OBJECT_VARIABLE: () => VariableItem[] = () => [
  {
    id: "objectIdentifier",
    name: i18n.t("BFDocument.variables.objectIdentifier", "Objekt - Nummer"),
  },
  {
    id: "objectName",
    name: i18n.t("BFDocument.variables.objectName", "Objekt - Name"),
  },
  {
    id: "objectCity",
    name: i18n.t("BFDocument.variables.objectCity", "Objekt - Stadt"),
  },
  {
    id: "objectStreetName",
    name: i18n.t("BFDocument.variables.objectStreet", "Objekt - Straße"),
  },
  {
    id: "objectZip",
    name: i18n.t("BFDocument.variables.objectZip", "Objekt - PLZ"),
  },
  {
    id: "objectStreetNumber",
    name: i18n.t(
      "BFDocument.variables.objectStreetNumber",
      "Objekt - Hausnummer"
    ),
  },
  {
    id: "units",
    name: i18n.t("BFDocument.variables.units", "Mieteinheiten"),
  },
];

export const BANK_VARIABLE: () => VariableItem[] = () => [
  {
    id: "bankName",
    name: i18n.t("BFDocument.variables.bankName", "Bankname"),
  },
  {
    id: "iban",
    name: i18n.t("BFDocument.variables.iban", "IBAN"),
  },
  {
    id: "bic",
    name: i18n.t("BFDocument.variables.bic", "BIC"),
  },

  {
    id: "rentNet",
    name: i18n.t("BFDocument.variables.rentNet", "Grundmiete - Netto"),
  },
  {
    id: "rentGross",
    name: i18n.t("BFDocument.variables.rentGross", "Grundmiete - Brutto"),
  },
  {
    id: "totalRent",
    name: i18n.t("BFDocument.variables.rent", "Gesamtmiete"),
  },
  {
    id: "rentNetPerQM",
    name: i18n.t("BFDocument.variables.rentNetPerQM", "Nettomiete/m²"),
  },
  {
    id: "rentGrossPerQM",
    name: i18n.t("BFDocument.variables.rentGrossPerQM", "Bruttomiete/m²"),
  },
  {
    id: "totalRentPerQM",
    name: i18n.t("BFDocument.variables.totalRentPerQM", "Gesamtmiete/m²"),
  },

  {
    id: "area",
    name: i18n.t("BFDocument.variables.area", "Fläche"),
  },
  {
    id: "operatingCostNet",
    name: i18n.t(
      "BFDocument.variables.operatingCostNet",
      "Betriebskosten - Netto"
    ),
  },
  {
    id: "operatingCostGross",
    name: i18n.t(
      "BFDocument.variables.operatingCostGross",
      "Betriebskosten - Brutto"
    ),
  },
  {
    id: "operatingCostGrossPerQM",
    name: i18n.t(
      "BFDocument.variables.operatingCostGrossPerQM",
      "Betriebskosten - Brutto/m²"
    ),
  },
  {
    id: "operatingCostNetPerQM",
    name: i18n.t(
      "BFDocument.variables.operatingCostNetPerQM",
      "Betriebskosten - Nettomiete/m²"
    ),
  },
];

export type LetterHeaderContent = {
  logo: string;
  documentDate?: string;
  activityId?: string;
  iban?: string;
  bic?: string;
  sender: {
    name?: string;
    street?: string;
    city?: string;
    zip?: string;
    country?: string;
    phone?: string;
    fax?: string;
    mail?: string;
    website?: string;
  };
  receiver: {
    name?: string;
    atHands?: string;
    street?: string;
    city?: string;
    country?: string;
  };
};

class BFDocumentServiceClass {
  getLetterHeader(content: LetterHeaderContent) {}
}
const BFDocumentService = new BFDocumentServiceClass();
export default BFDocumentService;
